import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import Avatar from '../images/avatar';
import { HStack, VStack } from '../layouts/stack.layout';
import Icon from '../icons/icon';
import Text from '../typography/v2/text';
import { me } from '../../test.data';
import { Link } from 'react-router-dom';

const DROPDOWN_MENU = {
  item: 'hover:bg-[#1c1c1c] hover:text-[#FFFFFF] rounded focus:outline-none px-6 cursor-pointer',
  group: 'px-6',
  footer: 'focus:outline-none',
  header: 'focus:outline-none',
};

export function ProfileDropdown() {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Avatar size="2xs" url={me.avatar} alt={`me`} />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        sideOffset={10}
        align="center"
        className="bg-[rgb(18,18,18)] py-2 px-1 rounded-lg shadow-feed"
      >
        <DropdownMenu.Group>
          <DropdownMenu.Item className={DROPDOWN_MENU.item}>
            <Link to={`/${me.username}`}>
              <HStack gap="base" extensions="pt-3 pb-3.5">
                <Avatar size="sm" url={me.avatar} alt="me" />
                <VStack gap="xs">
                  <Text variant="username">{me.displayName}</Text>
                  <Text variant="supplementary">@{me.username}</Text>
                </VStack>
              </HStack>
            </Link>
          </DropdownMenu.Item>
        </DropdownMenu.Group>
        <DropdownMenu.Separator className="h-[2px] mt-1 rounded-full bg-[#353535]" />
        <DropdownMenu.Group>
          <DropdownMenu.Item className={DROPDOWN_MENU['item']}>
            <Link to="/settings?tab=account">
              <HStack gap="base" extensions="py-3.5">
                <Icon icon="settings" />
                <Text variant="alt-navigation">Settings & privacy</Text>
              </HStack>
            </Link>
          </DropdownMenu.Item>
          <DropdownMenu.Item className={DROPDOWN_MENU['item']}>
            <Link to="/support">
              <HStack gap="base" extensions="py-3.5">
                <Icon icon="help" />
                <Text variant="alt-navigation">Help & Support</Text>
              </HStack>
            </Link>
          </DropdownMenu.Item>
        </DropdownMenu.Group>
        <DropdownMenu.Item className={DROPDOWN_MENU['item']}>
          <HStack gap="base" extensions="py-3.5">
            <Icon icon="logout" />
            <Text variant="alt-navigation">Logout</Text>
          </HStack>
        </DropdownMenu.Item>
        <DropdownMenu.Separator className="h-[2px] mt-1  rounded-full bg-[#353535] mb-1.5" />
        <DropdownMenu.Group className="flex flex-col gap-y-1 px-6 mb-2">
          <HStack gap="sm" extensions={DROPDOWN_MENU['footer']}>
            <Link to="/privacy">
              <Text color="primary" variant="supplementary">
                Privacy
              </Text>
            </Link>
            <Text variant="supplementary">·</Text>
            <Link to="/terms">
              <Text color="primary" variant="supplementary">
                Terms
              </Text>
            </Link>
            <Text variant="supplementary">·</Text>
            <Text variant="supplementary">© Holdr 2022</Text>
          </HStack>
        </DropdownMenu.Group>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
